import React, { useContext, useState } from 'react';
import { Card, CardBody, CardTitle, Table } from 'reactstrap';
import { useQuery } from '@tanstack/react-query';
import useAxios from '../../hooks/useAxios';
import { AuthContext } from '../../context/AuthContext';
import FetchStatus from '../../components/fetchStatus/FetchStatus';

const Attendance = () => {
  const [selectedMonthAndYear, setSelectedMonthAndYear] = useState(
    new Date().toISOString().slice(0, 7),
  );
  const { auth } = useContext(AuthContext);
  const api = useAxios();

  const { data, isLoading, error } = useQuery({
    queryKey: ['attendances', selectedMonthAndYear],
    queryFn: () =>
      api
        .get(
          `attendance/log/${auth?.employe_id}?month=${selectedMonthAndYear.split('-')[1]}&year=${
            selectedMonthAndYear.split('-')[0]
          }`,
        )
        .then((res) => {
          return res.data.data;
        }),
  });

  return (
    <Card className="rounded-4">
      <CardBody>
        <div className="d-flex justify-content-between">
          <CardTitle tag="h5">Riwayat Kehadiran</CardTitle>
          <div>
            <input
              type="month"
              className="form-control rounded-4"
              defaultValue={selectedMonthAndYear}
              onChange={(e) => setSelectedMonthAndYear(e.target.value)}
            />
          </div>
        </div>
        {isLoading ? (
          <FetchStatus type="loading" />
        ) : error ? (
          <FetchStatus type="error" />
        ) : (
          <div className="d-flex flex-column flex-md-row gap-3 mt-3">
            <div className="col-md-9 overflow-auto border rounded-4">
              <Table hover>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'center' }}>Tanggal</th>
                    <th style={{ textAlign: 'center' }}>Masuk (WIB)</th>
                    <th style={{ textAlign: 'center' }}>Pulang (WIB)</th>
                    <th style={{ textAlign: 'center' }}>Terlambat (Menit)</th>
                    <th style={{ textAlign: 'center' }}>Cepat Pulang (Menit)</th>
                    <th style={{ textAlign: 'center' }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.workdays.map((item) => (
                    <tr key={item.date}>
                      <td
                        style={{
                          verticalAlign: 'middle',
                          backgroundColor: item.isWeekend ? '#f7f7f7' : '',
                        }}
                      >
                        <div className="d-flex flex-column">
                          <strong>{item.day_name},</strong>
                          <span>{item.date}</span>
                        </div>
                      </td>
                      <td
                        style={{
                          verticalAlign: 'middle',
                          textAlign: 'center',
                          backgroundColor: item.isWeekend ? '#f7f7f7' : '',
                        }}
                      >
                        {!item.isWeekend ? item.time_in : ''}
                      </td>
                      <td
                        style={{
                          verticalAlign: 'middle',
                          textAlign: 'center',
                          backgroundColor: item.isWeekend ? '#f7f7f7' : '',
                        }}
                      >
                        {!item.isWeekend ? item.time_out : ''}
                      </td>
                      <td
                        style={{
                          verticalAlign: 'middle',
                          textAlign: 'center',
                          backgroundColor: item.isWeekend ? '#f7f7f7' : '',

                          color: item.late_minutes > 0 ? 'red' : '',
                        }}
                      >
                        {!item.isWeekend ? item.late_minutes : ''}
                      </td>
                      <td
                        style={{
                          verticalAlign: 'middle',
                          textAlign: 'center',
                          backgroundColor: item.isWeekend ? '#f7f7f7' : '',

                          color: item.early_minutes > 0 ? 'red' : '',
                        }}
                      >
                        {!item.isWeekend ? item.early_minutes : ''}
                      </td>
                      <td
                        style={{
                          verticalAlign: 'middle',
                          textAlign: 'center',
                          backgroundColor: item.isWeekend ? '#f7f7f7' : '',
                          color: item.status === 'Tanpa Keterangan' ? 'red' : '',
                        }}
                      >
                        {!item.isWeekend ? item.status : ''}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="col-md-3">
              <table>
                <tbody>
                  <tr>
                    <td style={{ lineHeight: '2' }}>Tidak hadir</td>
                    <td>: </td>
                    <td>
                      <strong>{data?.recap.total_absent}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ lineHeight: '2' }}>Tidak Absen Masuk</td>
                    <td>: </td>
                    <td>
                      <strong>{data?.recap.total_no_clockin || '0'}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ lineHeight: '2' }}>Tidak Absen Pulang</td>
                    <td>: </td>
                    <td>
                      <strong>{data?.recap.total_no_clockout || '0'}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ lineHeight: '2' }}>Total Keterlambatan</td>
                    <td>: </td>
                    <td>
                      <strong>{data?.recap.total_late_minutes} Menit</strong>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ lineHeight: '2' }}>Total Cepat Pulang</td>
                    <td>: </td>
                    <td>
                      <strong>{data?.recap.total_early_clockout} Menit</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default Attendance;
